var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors,
    spacing = _ref.spacing,
    borders = _ref.borders;
  return {
    contentBackgroundColor: colors.white,
    contentPaddingTopBottom: spacing.medium,
    contentPaddingLeftRight: spacing.xLarge,
    breadCrumbMarginBottom: spacing.large,
    headerPaddingBottom: spacing.large,
    headerBorderWidth: borders.widthSmall,
    headerBorderColor: colors.tiara
  };
};
export default generateComponentTheme;